import { isEmpty } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField } from 'modules/expenses/hooks/useExpensesCustomization'
import { subcategoriesForCategory } from 'modules/expenses/hooks/useExpensesCustomization'
import { Expensable } from 'modules/expenses/types/Expensable'

export const buildExpenseData = (
  expensable: Expensable,
  customizationFields: CustomizationField[],
  isOwnExpensable: boolean
) => {
  const showEmployeeInformation = !isOwnExpensable
  const employeeName = showEmployeeInformation ? expensable?.owner?.fullName : ''
  const category = expensable?.expense?.category?.name ?? ''

  const expenseSubcategories = subcategoriesForCategory(
    customizationFields,
    'expense',
    expensable?.expense?.category?.id ?? '',
    { includeHidden: true }
  )

  const subcategoryLabel =
    expenseSubcategories.find(
      (subcategory) => subcategory.value === expensable?.expense?.subcategory
    )?.label ?? ''

  const items = [
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.information_block.expense_owner'),
      info: employeeName,
    },
    {
      title: i18n.t('expenses_v2.confirmation_screen.expense.information_block.expense_category'),
      info: category,
    },
    {
      title: i18n.t(
        'expenses_v2.confirmation_screen.expense.information_block.expense_subcategory'
      ),
      info: subcategoryLabel,
    },
  ]

  return items.filter(({ info }) => !isEmpty(info))
}
